import React, { useState } from "react";
import useTranslation from "next-translate/useTranslation";
import { updateSetting, useSettings } from "../../redux/settings";
import { Slider, Handles, Tracks, Rail } from "react-compound-slider";
import { Handle, SliderRail, Track } from "../../components/ui/range-slider";

import styles from "./styles/Settings.module.css";
import Toggle from "../../components/ui/toggle";

export default function GameFilter() {
  const { minOpponentRating, maxOpponentRating, noGuests } = useSettings();

  const defaultValues = [minOpponentRating, maxOpponentRating];

  const { t } = useTranslation("common");
  const { t: settingsT } = useTranslation("auth");

  const [minRating, setMinRating] = useState(minOpponentRating);
  const [maxRating, setMaxRating] = useState(maxOpponentRating);

  const handleSliderUpdate = (values) => {
    setMinRating(values[0]);
    setMaxRating(values[1]);
  };

  const handleSliderChange = (values) => {
    updateSetting("minOpponentRating", values[0]);
    updateSetting("maxOpponentRating", values[1]);
  };

  return (
    <div className={styles.body}>
      <div className={styles.title}>{settingsT("Game filter")}</div>
      <div className="mt-2">
        {t("Opponent rating")}:
        <span
          style={{ fontWeight: 600 }}
        >{` ${minRating} - ${maxRating}`}</span>
      </div>
      <div className="mt-2 h-6">
        <Slider
          step={10}
          mode={5}
          domain={[0, 4000]}
          rootStyle={{
            position: "relative",
            margin: "12px",
            marginLeft: "12px",
            marginBottom: "22px",
          }}
          onUpdate={handleSliderUpdate}
          onChange={handleSliderChange}
          values={defaultValues}
        >
          <Rail>
            {({ getRailProps }) => <SliderRail getRailProps={getRailProps} />}
          </Rail>
          <Handles>
            {({ handles, getHandleProps }) => (
              <div className="slider-handles">
                {handles.map((handle, i) => (
                  <Handle
                    key={handle.id}
                    handle={handle}
                    domain={[0, 4000]}
                    getHandleProps={getHandleProps}
                  />
                ))}
              </div>
            )}
          </Handles>
          <Tracks left={false} right={false}>
            {({ tracks, getTrackProps }) => (
              <div className="slider-tracks">
                {tracks.map(({ id, source, target }) => (
                  <Track
                    key={id}
                    source={source}
                    target={target}
                    getTrackProps={getTrackProps}
                  />
                ))}
              </div>
            )}
          </Tracks>
        </Slider>
      </div>

      <div className="mt-7 mb-2">{settingsT("Play against guests")}</div>
      <Toggle
        active={!noGuests}
        onToggle={(isOn) => updateSetting("noGuests", !isOn)}
      />
    </div>
  );
}
